import { Center, Box, Title, Text, Button, useMantineTheme } from '@mantine/core';

const EmbedErrorComponent = ({
  themeColor,
  closeButton,
}: {
  themeColor?: string;
  closeButton: () => void;
}) => {
  const theme = useMantineTheme();

  return (
    <Center h={'100%'}>
      <Box
        style={{
          textAlign: 'center',
          padding: '24px',
        }}
      >
        <Title order={4} mb="lg" c={theme.colors.blue[5]}>
          Attention!
        </Title>
        <Text fw={500} size="md" c={theme.colors.blue[8]}>
          Your browser is set to private/incognito. Switch to normal mode or allow third party
          cookies.
        </Text>
        <Button
          onClick={closeButton}
          mt={24}
          size="md"
          radius="lg"
          style={{
            backgroundColor: themeColor ? `#${themeColor}` : theme.colors.pink[5],
            color: 'white',
            '&:hover': {
              backgroundColor: themeColor ? `#${themeColor}aa` : theme.other.pinkHover,
            },
          }}
        >
          OK
        </Button>
      </Box>
    </Center>
  );
};

export default EmbedErrorComponent;
